import React from 'react';
import { Icon, IconColor, IconSize } from '../../../../icon';
import { Link } from '../../../../link';
import styles from './link-cell.module.scss';
export const LinkCell = ({ data, colDef, }) => {
    const linkData = (colDef === null || colDef === void 0 ? void 0 : colDef.colId) ? data[colDef.colId] : {};
    return (React.createElement("div", { className: styles.linkCellContainer },
        linkData.icon && (React.createElement("div", { className: styles.linkIconContainer },
            React.createElement(Icon, { id: linkData.icon, color: IconColor.TEXT_COLOR, size: IconSize.MEDIUM }))),
        React.createElement(Link, { color: "blue", href: linkData.href, className: styles.link, target: linkData.target || '_self' }, linkData.text)));
};
//# sourceMappingURL=link-cell.js.map